// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2Eu3f","checkboxCol":"Table_checkboxCol__3vLIl","emailCol":"Table_emailCol__2Zud1","actionCol":"Table_actionCol__1audF"};